import { render, staticRenderFns } from "./HowToBuy.vue?vue&type=template&id=6d0d33ea&scoped=true&"
import script from "./HowToBuy.vue?vue&type=script&lang=js&"
export * from "./HowToBuy.vue?vue&type=script&lang=js&"
import style0 from "./HowToBuy.vue?vue&type=style&index=0&id=6d0d33ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0d33ea",
  null
  
)

export default component.exports